<dxp-flex-layout class="result-grid" *ngIf="showSearchContent && this.customTitle == ''">
    <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12" padding-style-sm="16px 15px 0px">
        <p class="dxp-bold dxp-uppercase result-font">Results</p>
    </dxp-flex-layout-item>
</dxp-flex-layout>
<dxp-flex-layout class="result-grid" *ngIf="this.customTitle != ''">
    <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12" padding-style-sm="16px 15px 0px">
        <p class="dxp-bold dxp-uppercase result-font">{{this.customTitle}}</p>
    </dxp-flex-layout-item>
</dxp-flex-layout>
<dxp-flex-layout class="result-grid" *ngIf="instructionMessage">
    <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12" padding-style-sm="10px 15px 0px">
        <p class="action-message-14px">{{instructionMessage}}</p>
    </dxp-flex-layout-item>
</dxp-flex-layout>
<div class="dxp-flex dxp-flex-row result-grid" *ngIf="hasAction || export">
    <div class="dxp-p-4" *ngIf="hasAction">
        <common-result-grid-actions class="dropdown-actions"></common-result-grid-actions>
    </div>
    <div class="dxp-p-4">
        <common-export class="dropdown-actions" *ngIf="export" [userJourneyName]="userJourneyName"
            [exportType]="this.exportType"></common-export>
    </div>
</div>
<dxp-flex-layout class="result-grid">
    <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12"
        [ngStyle]="{'padding-style-sm': this.determineGridContainerPadding()}">
        <ag-grid-angular style="width: 100%;"
            [ngStyle]="{'height': this.detemineGridHeight()}"
            class="ag-theme-alpine dxp-theme-b2b" [tooltipShowDelay]="this.tooltipShowDelay" [rowData]="this.rowData"
            [columnDefs]="this.columnDefinitions" [rowSelection]="this.rowSelection" [suppressRowClickSelection]="this.suppressRowClilckSelection"
            [defaultColDef]="this.defaultColumnDefinitions" [overlayNoRowsTemplate]="this.noRowsTemplate"
            [overlayLoadingTemplate]="this.loadingTemplate" (gridReady)="this.onGridReady($event)" [context]="this.context"
            [ensureDomOrder]="true" [enableCellTextSelection]="true" (rowSelected)="onRowSelected()">
        </ag-grid-angular>
    </dxp-flex-layout-item>
</dxp-flex-layout>
<dxp-flex-layout class="result-grid" *ngIf="pagination && this.rowData.length > 0">
    <dxp-flex-layout-item slot="column-1" column-width-sm="12" column-width-lg="12" padding-style-sm="15px">
        <dxp-pagination [pageSize]="this.pageSize" [totalUnits]="this.totalRecords"
            [currentPageIndex]="this.currentPageIndex" position="left" (toPageNumber)="this.moveToPage($event)">
        </dxp-pagination>
    </dxp-flex-layout-item>
</dxp-flex-layout>